/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are my options saved?`)
};

const es_dw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Se guardan mis opciones?`)
};

const de_dw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werden meine Optionen gespeichert?`)
};

const nl_dw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Worden mijn opties opgeslagen?`)
};

const fr_dw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes options sont-elles enregistrées ?`)
};

const it_dw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le mie opzioni vengono salvate?`)
};

const pt_br2_dw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minhas opções ficam salvas?`)
};

const pt_dw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As minhas opções ficam guardadas?`)
};

const ja_dw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択肢は保存されますか?`)
};

const zh_dw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的选项会被保存吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dw_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dw_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dw_faq_q4", locale)
	if (locale === "en") return en_dw_faq_q4(inputs)
	if (locale === "es") return es_dw_faq_q4(inputs)
	if (locale === "de") return de_dw_faq_q4(inputs)
	if (locale === "nl") return nl_dw_faq_q4(inputs)
	if (locale === "fr") return fr_dw_faq_q4(inputs)
	if (locale === "it") return it_dw_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_dw_faq_q4(inputs)
	if (locale === "pt") return pt_dw_faq_q4(inputs)
	if (locale === "ja") return ja_dw_faq_q4(inputs)
	return zh_dw_faq_q4(inputs)
};